import { SurveyTypes } from '../../../interfaces/surveys.interfaces';

export const surveyTypeNames: SurveyTypes = {
  general: 'general',
  three_sixty: 'three_sixty',
  bottom_up: 'bottom_up',
  top_down: 'top_down',
  groups: 'groups',
};

export enum SurveyTypeIcons {
  general = 'iconPulse',
  three_sixty = 'icon360',
  bottom_up = 'iconBottomUp',
  top_down = 'iconTopDown',
  groups = 'iconGroups',
}

export type SurveyTypeIcon = 'iconPulse' | 'icon360' | 'iconBottomUp' | 'iconTopDown' | 'iconGroups';

export interface SurveyTypeData {
  value: keyof SurveyTypes;
  name: string;
  iconName: SurveyTypeIcon;
  description: string;
}

export const surveyTypes: SurveyTypeData[] = [
  {
    value: surveyTypeNames.general,
    name: 'x.surveys.add.pulse',
    iconName: SurveyTypeIcons[surveyTypeNames.general],
    description: 'x.surveys.add.pulse.description',
  },
  {
    value: surveyTypeNames.three_sixty,
    name: 'x.surveys.add.three_sixty',
    iconName: SurveyTypeIcons[surveyTypeNames.three_sixty],
    description: 'x.surveys.add.three_sixty.description',
  },
  {
    value: surveyTypeNames.bottom_up,
    name: 'x.surveys.add.bottom_up',
    iconName: SurveyTypeIcons[surveyTypeNames.bottom_up],
    description: 'x.surveys.add.bottom_up.description',
  },
  {
    value: surveyTypeNames.top_down,
    name: 'x.surveys.add.top_down',
    iconName: SurveyTypeIcons[surveyTypeNames.top_down],
    description: 'x.surveys.add.top_down.description',
  },
  {
    value: surveyTypeNames.groups,
    name: 'x.surveys.add.groups',
    iconName: SurveyTypeIcons[surveyTypeNames.groups],
    description: 'x.surveys.add.groups.description',
  },
];
